const utf8Decoder = new TextDecoder();
export const decoder = {
    decode: (array) => {
        return utf8Decoder.decode(array);
    },
};
//# sourceMappingURL=utf8Decoder.js.map